import { z } from 'zod';

const signupSchema = z
   .object({
      first_name: z.string().trim().min(1, 'Name is required'),
      last_name: z.string().trim().min(1, 'Surname is required'),
      email: z.string().trim().min(1, 'Email is required').email('Invalid email address'),
      password: z
         .string()
         .trim()
         .min(12, 'Password must be at least 12 characters')
         .regex(
            /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]).*$/,
            'Password must include at least one uppercase letter, one number, and one special character',
         ),
      confirmPassword: z.string().trim().min(12, 'Password must be at least 12 characters'),
   })
   .refine(data => data.password === data.confirmPassword, {
      path: ['confirmPassword'],
      message: 'Passwords do not match',
   });

type TSignup = z.infer<typeof signupSchema>;

export { signupSchema };
export type { TSignup };
